import { Flex } from "@chakra-ui/react";
import { FormattedMessage, useIntl } from "react-intl";

import { isValidTRTNumber } from "flows/Activities/utils/trtNumber";
import { useCountryCode } from "shared/hooks/useCountryCode";
import { Form } from "ui/Form/Form";
import { Input } from "ui/Input/Input";
import { TitleM } from "ui/Typography/Typography";

type BasicInformationProps = {
  pickupDate: string;
  onPickupDateChange: (date: string) => void;
  TRTNumber: string;
  onTRTNumberChange: (value: string) => void;
};

export function BasicInformation({
  pickupDate,
  onPickupDateChange,
  TRTNumber,
  onTRTNumberChange,
}: BasicInformationProps) {
  const intl = useIntl();
  const countryCode = useCountryCode();

  const isTRTNumberInvalid = TRTNumber.length > 0 && !isValidTRTNumber(TRTNumber);

  const handleTRTNumberChange = (value: string) => {
    const digitsOnly = value.replace(/\D/g, "").slice(0, 7);
    onTRTNumberChange(digitsOnly);
  };

  return (
    <>
      <TitleM pt="s300" px="s200" pb="s200">
        {intl.formatMessage({
          id: "components.activities.transport-equipment.count-page.info.title",
        })}
      </TitleM>
      <Flex bg="white" borderRadius="sm" p="s200" gap="s200" direction="column">
        <Input
          type="date"
          value={pickupDate}
          onChange={(e) => onPickupDateChange(e.target.value)}
          placeholder={intl.formatMessage({
            id: "components.activities.transport-equipment.count-page.date-placeholder",
          })}
        />
        {countryCode === "de" && (
          <Form.Field isInvalid={isTRTNumberInvalid}>
            <Input
              type="text"
              inputMode="numeric"
              maxLength={7}
              value={TRTNumber}
              placeholder={intl.formatMessage({
                id: "components.activities.transport-equipment.count-page.number-placeholder",
              })}
              onChange={(e) => handleTRTNumberChange(e.target.value)}
              _invalid={{ color: "red.500", borderColor: "red.500" }}
            />
            {isTRTNumberInvalid && (
              <Form.ErrorMessage color="red.500">
                <FormattedMessage id="components.activities.transport-equipment.count-page.number-validation.error" />
              </Form.ErrorMessage>
            )}
          </Form.Field>
        )}
      </Flex>
    </>
  );
}
